/* ════════════════════════════════════════════════════════════════════════
   KILIM — COMPORTEMENTS DE L'EN-TETE
   Porté de design/commun.js. Chargé en `defer` par sections/entete.liquid.

   Deux choses, et rien d'autre : le tiroir de navigation sur mobile, et
   l'ouverture du mégamenu de bureau. La barre ne se rétracte plus (voir le
   bloc en fin de fichier). Le panneau du mégamenu, lui, reste dans le
   document ouvert comme fermé — `:focus-within` l'ouvre au clavier sans
   JavaScript, et un robot le lit dans tous les cas.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  var entete = document.querySelector('.entete');
  if (!entete) return;

  var burger = entete.querySelector('.entete__burger');
  var nav = entete.querySelector('.entete__nav');
  var mobile = function () { return matchMedia('(max-width: 900px)').matches; };

  /* ── Le tiroir ─────────────────────────────────────────────────────────
     L'état vit dans un attribut, sur l'en-tête et sur le corps : une seule
     source, et le CSS fait le reste (§14). Le corps le porte aussi parce
     que c'est lui qui cesse de défiler derrière le tiroir. */
  /* Tiroir ouvert, la barre n'est plus flottante au-dessus d'un hero : elle
     EST le châssis du menu. On change donc l'état lui-même plutôt que de
     surenchérir en CSS contre les règles de page — `.entete[data-etat=
     "flottante"][data-fond="sombre"]` y passe le texte en blanc, et un blanc
     sur le fond plein du tiroir ne se lit pas. L'état d'origine est rendu à
     la fermeture. */
  var etatRendu = null;

  /* Les vignettes du sous-menu sont en `lazy` : sans ce coup de pouce elles
     ne partaient qu'au dépliage, et arrivaient après l'animation. On les
     demande dès l'ouverture du tiroir, une seule fois. */
  var vignettesDemandees = false;
  function demanderVignettes() {
    if (vignettesDemandees) return;
    vignettesDemandees = true;
    Array.prototype.forEach.call(
      entete.querySelectorAll('.megamenu__vignette img'),
      function (img) { img.loading = 'eager'; });
  }

  function tiroir(ouvert) {
    if (ouvert) demanderVignettes();
    if (ouvert && etatRendu === null) {
      etatRendu = { etat: entete.dataset.etat || '', fond: entete.dataset.fond || '' };
      entete.dataset.etat = 'pleine';
      entete.removeAttribute('data-fond');
    } else if (!ouvert && etatRendu !== null) {
      if (etatRendu.etat) entete.dataset.etat = etatRendu.etat;
      else entete.removeAttribute('data-etat');
      if (etatRendu.fond) entete.dataset.fond = etatRendu.fond;
      etatRendu = null;
    }
    entete.dataset.menu = ouvert ? 'ouvert' : 'ferme';
    document.body.dataset.menu = ouvert ? 'ouvert' : 'ferme';
    if (burger) burger.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    if (!ouvert) replierTout();
  }

  if (burger) {
    burger.addEventListener('click', function () {
      tiroir(burger.getAttribute('aria-expanded') !== 'true');
    });
  }

  /* ── Les accordéons de famille ─────────────────────────────────────────
     Sur mobile seulement : en bureau, le survol ouvre le panneau et ces
     boutons sont masqués. Un seul panneau ouvert à la fois — deux panneaux
     déployés font défiler le tiroir sans qu'on sache d'où l'on vient. */
  var boutons = Array.prototype.slice.call(entete.querySelectorAll('.entete__deplier'));

  function replierTout() {
    boutons.forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var panneau = document.getElementById(b.getAttribute('aria-controls'));
      if (panneau) panneau.removeAttribute('data-ouvert');
    });
  }

  boutons.forEach(function (b) {
    b.addEventListener('click', function () {
      var ouvert = b.getAttribute('aria-expanded') === 'true';
      var panneau = document.getElementById(b.getAttribute('aria-controls'));
      replierTout();
      if (!ouvert) {
        b.setAttribute('aria-expanded', 'true');
        if (panneau) panneau.setAttribute('data-ouvert', '');
      }
    });
  });

  /* ── Le mégamenu de bureau s'ouvre au SURVOL ─────────────────────────
     Révision du 21/09/2026. Il s'ouvrait au clic ; il s'ouvre maintenant au
     passage du curseur, sans qu'on ait rien à cliquer.

     Le clic n'a PAS disparu pour autant, et c'est délibéré : sur un écran
     tactile il n'y a pas de survol, et c'est lui qui ouvre. Les deux chemins
     coexistent sans se gêner — à la souris, le panneau est déjà ouvert quand
     le clic arrive, donc le clic navigue ; au doigt, le premier appui ouvre
     et le second navigue.

     LE BATTEMENT EST TRAITÉ PAR LA GÉOMÉTRIE, PAS PAR UN DÉLAI. Le panneau
     est posé sous la barre, en `position: absolute` sur `.entete` : entre le
     libellé et le panneau il y a donc le reste de la hauteur de barre, qui
     n'appartient à aucune famille. Fermer sur le `mouseleave` de la famille
     ferait tomber le panneau à chaque descente du curseur vers lui. On ferme
     donc sur le `mouseleave` de l'EN-TÊTE ENTIER : tant que le curseur est
     dans la barre ou dans le panneau, rien ne se ferme, et il n'y a aucun
     `setTimeout` à régler.

     Le survol n'est branché que sur les pointeurs fins : `(hover: hover) and
     (pointer: fine)`. Sur un mobile qui émule le survol, un panneau plein
     écran tomberait au premier effleurement.

     Rien de tout ça sur mobile : là, ce sont les boutons `.entete__deplier`
     qui commandent, et ils existaient déjà. */
  var survol = matchMedia('(hover: hover) and (pointer: fine)');
  function fermerPanneaux(sauf) {
    boutons.forEach(function () {});
    Array.prototype.forEach.call(
      entete.querySelectorAll('.entete__famille[data-ouvert]'),
      function (f) { if (f !== sauf) f.removeAttribute('data-ouvert'); });
  }

  Array.prototype.forEach.call(
    entete.querySelectorAll('.entete__famille'),
    function (famille) {
      var lien = famille.querySelector(':scope > a');
      if (!lien || !famille.querySelector('.megamenu')) return;

      lien.addEventListener('click', function (e) {
        if (mobile()) return;
        if (famille.hasAttribute('data-ouvert')) return;   // 2e clic : on navigue
        e.preventDefault();
        fermerPanneaux(famille);
        famille.setAttribute('data-ouvert', '');
      });
    });

  /* Le survol ouvre. Posé sur TOUTES les familles, y compris celles sans
     panneau : passer sur « Contact » doit refermer « Hijab », sinon le
     panneau reste suspendu au-dessus d'un libellé qu'on a quitté. */
  Array.prototype.forEach.call(
    entete.querySelectorAll('.entete__famille'),
    function (famille) {
      famille.addEventListener('mouseenter', function () {
        if (mobile() || !survol.matches) return;
        fermerPanneaux(famille);
        if (famille.querySelector('.megamenu')) famille.setAttribute('data-ouvert', '');
      });
    });

  entete.addEventListener('mouseleave', function () {
    if (mobile() || !survol.matches) return;
    fermerPanneaux(null);
  });

  /* Un clic hors de l'en-tête referme : sans ça le panneau reste ouvert
     par-dessus la page qu'on essaie de lire. */
  document.addEventListener('click', function (e) {
    if (!entete.contains(e.target)) fermerPanneaux(null);
  });

  /* Échap ferme ce qui est ouvert, et rend le focus au bouton : c'est la
     seule façon de sortir du tiroir au clavier. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (entete.dataset.menu === 'ouvert') { tiroir(false); if (burger) burger.focus(); }
    else if (entete.querySelector('.entete__famille[data-ouvert]')) { fermerPanneaux(null); }
    else if (document.activeElement && entete.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  });

  /* Le passage bureau → mobile referme tout : un panneau de mégamenu laissé
     ouvert par le survol reste visible dans le tiroir sinon. */
  addEventListener('resize', function () { if (!mobile()) tiroir(false); });

  /* ── LA BARRE NE SE RETRACTE PLUS ────────────────────────────────────
     Bloc supprime le 20/09/2026.

     Il masquait la barre au defilement descendant et la ramenait au premier
     defilement remontant. Deux problemes, l'un de forme, l'autre de fond.

     De fond : deviner une intention de defilement a partir de micro-mouvements
     du doigt ne marche pas. Mesure en conditions reelles : 14 changements
     d'etat par defilement, dont 9 a moins de 250 ms, avec une transition de
     240 ms — la barre n'arrivait jamais et oscillait. Une hysteresis
     asymetrique ramenait le compte a 1, mais traitait le symptome.

     De forme : la reference du corpus, cocoonblanket.com, ne fait pas ca.
     Mesure du 20/09 : leur barre reste a `top: 40px` a TOUTES les positions
     de defilement, sur bureau comme sur mobile. Seule la couleur du texte
     fond, en 0,3 s, selon la section survolee.

     Une couleur qui fond ne peut pas trembler : elle n'occupe pas de place,
     donc elle ne deplace rien. La bascule de couleur vit dans
     kilim-accueil.js et kilim-pdp.js, qui ecrivent `data-fond`. */
})();
